<template>
    <!-- 问题研讨 -->
    <div class="discu-box">
        <div class="title">{{ $t('全部回复') }}</div>

        <div class="question-box">
            <template v-if="dataList.length > 0">

                <div class="list" v-for="(item, index) in dataList" :key="index">
                    <div class="info df aic">
                        <div @click="item.tpa_type == 10 ? handleOpenavatar(item) : ''" class="df cup">
                            <el-avatar :size="24"
                                :src="item.tpa_type == 10 ? item.user_avatar_url : require('@/assets/images/avatar.png')"
                                @error="true">
                                <img src="@/assets/images/avatar.png" alt="">
                            </el-avatar>
                        </div>
                        <span class="name">{{ item.tpa_type == 20 ? $t('匿名用户') : ((item.is_expert == 10) ?
                            (item.user_name == "" ? item.user_nickname : item.user_nick_name) : item.user_nick_name) }}</span>

                            <!-- 版主评论和版主点赞 -->
                        <div class="moderator-box ml-12 df">
                            <!-- 评论 icon-pinglun      点赞 icon-dianzan_kuai  -->
                            <template v-if="item.data_is_moderator && item.tpa_type == 10">
                              <div class="box-1"><span class="iconfont icon-pinglun"></span></div>
                              <div class="box-2">{{ $t('版主评论') }}</div>
                            </template>
                          <template v-if="item.data_have_be_moderator_like">
                              <div class="box-1"><span class="iconfont icon-dianzan_kuai"></span></div>
                              <div class="box-2">{{ $t('版主点赞') }}</div>
                            </template>
                        </div>


                    </div>
                    <!-- 是否是精华帖 -->
                
                    <div class="essence-box" v-if="item.tpa_rec == 900">
                      <template>
                        <img :src="require('@/assets/images/essence-'+currentLanguge+'.png')" alt="">
                      </template>
                    </div>

                    <!-- 问卷回答内容 -->
                    <div v-if="item.content_type === 'questionnaire'" class="questionnaire-content">
                        <div class="questionnaire-body">
                            <div class="questionnaire-answer">
                                <div class="ques-item" v-for="(subject, index) in item.questionnaire_data.subjects" :key="subject.tqs_id">
                                    <!-- 题目标题 -->
                                    <div class="ques-title">
                                        <span class="ques-no">{{ index + 1 }}、</span>
                                        <span class="type-text">【{{ getQuestionTypeText(subject.tqs_type) }}】</span>
                                        <p class="title-text">{{ subject.tqs_content }}</p>
                                    </div>
                                    
                                    <!-- 选择题/多选题答案 -->
                                    <div v-if="subject.tqs_type == 10 || subject.tqs_type == 20" class="answer-options">
                                        <template v-for="(option, oi) in subject.options">
                                            <div v-if="option.is_selected" :key="option.tqo_id" class="selected-option">
                                                • {{ optionLetter(oi) }}、{{ option.tqo_content }}
                                            </div>
                                        </template>
                                        <!-- 追问内容 -->
                                        <template v-for="option in subject.options">
                                            <div v-if="option.is_selected && option.probe_content" :key="'probe_' + option.tqo_id" class="probe-content">
                                                {{ option.probe_content }}
                                            </div>
                                        </template>
                                    </div>
                                    
                                    <!-- 评分题答案 -->
                                    <div v-else-if="subject.tqs_type == 30" class="score-answers">
                                        <template v-for="(option, oi) in subject.options">
                                            <div v-if="option.user_score > 0" :key="option.tqo_id" class="score-item-answer">
                                                • {{ optionLetter(oi) }}、{{ option.tqo_content }} - {{ option.user_score }}分
                                            </div>
                                        </template>
                                        <!-- 评分题追问内容 -->
                                        <template v-for="option in subject.options">
                                            <div v-if="option.user_score > 0 && option.probe_content" :key="'score_probe_' + option.tqo_id" class="probe-content">
                                                {{ option.probe_content }}
                                            </div>
                                        </template>
                                    </div>
                                    
                                    <!-- 主观题答案 -->
                                    <div v-else-if="subject.tqs_type == 40 && subject.options[0] && subject.options[0].user_content" class="subjective-answer">
                                        {{ subject.options[0].user_content }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 普通回复内容 -->
                    <div v-else class="desc" v-html="item.tpa_content">
                    </div>


                    <div class="like-box df aic jcsb">
                        <div class="pl-36">
                            <span class="c-6 fs-14">{{ item.create_time }}</span>
                        </div>
                      <div class="df jcfe">
                        <!-- 问卷回答的操作按钮 -->
                        <template v-if="item.content_type === 'questionnaire'">
                          <!-- 问卷回答不显示操作按钮 -->
                        </template>
                        
                        <!-- 普通回复的操作按钮 -->
                        <template v-else>
                          <template v-if="is_moderator == 10">
                            <el-button type="text" @click="handleEssence(item)" class="df aic" v-throttle="1000" :class="{ 'have_like': item.tpa_rec == 900 }">
                              <span class="iconfont icon-jiangbei"></span>
                              <span class="hava-text">
                                  {{ item.tpa_rec == 900 ? $t('取消精华评论') : $t('置为精华评论') }}
                              </span>
                            </el-button>
                          </template>

                          <el-button type="text" class="df aic" v-throttle="1000" @click="handleReplyPer(item)">
                            <span class="iconfont fs-15">&#xe60b;</span>{{ $t('回复') }}</el-button>

                          <el-button type="text" class="df aic" v-throttle="1000"
                                     :class="{ 'have_like': item.data_have_be_like }" @click="handleactQuestionLike(item)"
                                     :loading="item.is_loading">
                            <span class="iconfont">{{ item.data_have_be_like ? '&#xe656;' : '&#xe61b;' }}</span>
                            <span class="hava-text">
                                  {{ item.tpa_likes ? item.tpa_likes : $t('点赞') }}
                              </span>
                          </el-button>
                          
                          <el-button v-if="userinfo.user_id == item.user_id" type="text" class="df aic" v-throttle="1000" @click="handleDelete(item)"
                                     :loading="item.delete_loading">
                            <span class="iconfont fs-15">&#xe622;</span>{{ $t('删除') }}
                          </el-button>
                        </template>
                      </div>
                    </div>

                    <div v-if="item.children.length > 0" style="padding-left:40px;">

                        <reply-list v-for="(items, indexs) in item.children" :key="indexs" :parentItem="item" :item="items" :userinfo="userinfo"
                            :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" :handleEssence="handleEssence" :handleDelete="handleDelete" :is_moderator="is_moderator" />
                    </div>

                </div>

            </template>
            <div class="no_news df fdc jcc aic" v-else>
                <img src="@/assets/images/no_news.png" alt="">
                <p>{{ $t('暂无消息') }}</p>
            </div>
        </div>

        <div>
            <!-- <div class="reply-box df aic">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入内容')"
                    v-model="textarea">
                </el-input>
                <el-button type="text" class="ml-20" @click="handleReply" :loading="replyLoading">
                    <img src="@/assets/images/public_send.png" alt=""></el-button>
            </div> -->
            <div>
                <div class="reply-box df aic">
                <el-input 
                    ref="textareaRef"
                    type="textarea" 
                    :autosize="{ minRows: 2, maxRows: 10 }" 
                    :placeholder="$t('请输入内容')"
                    v-model="textarea"
                >
                </el-input>
                
                <!-- 添加链接插入按钮 -->
                <el-tooltip :content="$t('插入链接')" placement="top">
                    <el-button type="text" class="ml-20 custom-link-btn" @click="openLinkDialog(1)">
                    <i class="el-icon-link"></i>
                    </el-button>
                </el-tooltip>
                
                <el-button 
                    type="text" 
                    class="ml-20" 
                    @click="handleReplyLink" 
                    :loading="replyLoading"
                >
                    <img src="@/assets/images/public_send.png" alt="">
                </el-button>
                </div>
            </div>

            <!--  v-if="userinfo.user_expert == 10" -->
            <div class="languige-text harmonyos-text mt-16 df aic jcfe" v-if="userinfo.user_expert == 10 && false">
                {{ $t('以实名身份发布') }}
                <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                    <span class="iconfont">&#xe677;</span>
                </el-tooltip>
                <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">
                    <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                </el-checkbox-group>
            </div>

        </div>

        <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" @close="handleClose" width="570px">

            <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')" ref="textareaRefDialog"
                    v-model="textareaper"></el-input>
                <!-- 添加链接插入按钮 -->
                <el-tooltip :content="$t('插入链接')" placement="top">
                    <el-button type="text" class="ml-20 custom-link-btn" @click="openLinkDialog(2)">
                    <i class="el-icon-link"></i>
                    </el-button>
                </el-tooltip>
            </div>
            <div class="languige-text harmonyos-text mt-24" v-if="userinfo.user_expert == 10 && false">
                {{ $t('以实名身份发布') }}
                <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                    <span class="iconfont">&#xe677;</span>
                </el-tooltip>
                <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">
                    <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                </el-checkbox-group>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" class="btn2" :loading="replyLoading" @click="handelSubPerLink">{{ $t('确定')
                    }}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogVisibleLink"
            :title="$t('请输入链接地址')"
            @close="handleCloseLink"
            >
            <el-input v-model="linkUrl" :placeholder="$t('请输入链接地址')" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleLink = false">{{ $t('取消') }}</el-button>
                <el-button type="primary" @click="insertLink">{{ $t('确认') }}</el-button>
            </span>
        </el-dialog>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="ac_id" />

    </div>
</template>

<script>
import {ansList, deletePostAns, essencePostAns, likePostAns, replyPostAns} from "@api/post";
import { getMyInfo, setuserfollowAdd } from "@api/home";
import replyList from "./replyList.vue";
import {setTopicAnsDel} from "@api/subject";
import { markdownToHtml,isValidUrl } from '@/utils/markdownUtils';
import { creationLetter } from "@utils";

export default {
    components: {
        replyList
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        data: {
            type: Array,
            default: []
        },
        is_moderator: {
            type: Number,
            default: 20
        },
    },
    data() {
        return {
            currentLanguge: localStorage.getItem('currentLanguage') || 'zh',
            dialogVisible: false,  //回复弹框
            dataList: [],
            userinfo: [],
            textarea: '',
            textareaper: '',  //回复别人的评论
            is_expert: [10],  //回复别人的评论
            personObj: {},

            ac_id: 0,
            replyLoading: false,
            likeLoading: false,
            previewHtml: '',
            dialogVisibleLink: false,  // 控制 Dialog 显示
            linkUrl: '',           // 存储用户输入的链接
            linkType:1,
            linkToContent:'',
        }
    },
    watch: {
        data: {
            handler(newData) {
                this.dataList = this.data;
            },
            deep: true, // 如果需要深度监听数组中的对象变化，可以设置为 true
            immediate: true // 如果希望在组件创建时立即执行一次 handler
        }
    },

    mounted() {
        this.dataList = this.data;
        this.getCurrUserData();
    },
    methods: {
        optionLetter(index) {
            return creationLetter(index);
        },
        openLinkDialog(type) {
            this.linkUrl = '';
            this.linkType = type; // 保存类型
            this.dialogVisibleLink = true; // 打开 Dialog
        },
        insertLink(type) {
            const url = this.linkUrl;
            if (url == '') {
                this.$message.warning(this.$t('请输入链接地址'));
                return;
            }
            if (url) {
                if (!isValidUrl(url)) {
                    this.$message.warning(this.$t('请输入正确的链接地址'));
                    return;
                }
                // 自动提取域名作为显示文本
                try {
                const urlObj = new URL(url);
                } catch (e) {
                // 不是完整URL则保持原样
                }
                // 插入Markdown格式链接
                const markdownLink = `${url}`;
                if(this.linkType == 1){
                    this.textarea = this.insertAtCursor(this.textarea, markdownLink,this.linkType);
                }else{
                    this.textareaper = this.insertAtCursor(this.textareaper, markdownLink,this.linkType);
                }
                
            }
        },
        
        // 在光标位置插入文本
        insertAtCursor(text, insertText, type) {
            // 获取正确的输入组件
            const inputComponent = type === 1 
                ? this.$refs.textareaRef 
                : this.$refs.textareaRefDialog;
            
            // 获取原生 textarea 元素
            let textarea = null;
            
            if (inputComponent && inputComponent.$refs && inputComponent.$refs.textarea) {
                textarea = inputComponent.$refs.textarea;
            }
            
            // 如果没有获取到 textarea，直接返回原始文本
            if (!textarea) {
                console.error("无法获取 textarea 元素");
                return text;
            }
            
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const insertTextLink = ` ${insertText} `;
            // 更新文本
            const newText = text.substring(0, start) + insertTextLink + text.substring(end);
            
            // 更新光标位置
            this.$nextTick(() => {
                textarea.selectionStart = start + insertTextLink.length;
                textarea.selectionEnd = start + insertTextLink.length;
                textarea.focus();
            });
            this.linkUrl = '';
            this.dialogVisibleLink = false;
            return newText;
        },
        
        // 获取题目类型文本
        getQuestionTypeText(type) {
            switch (type) {
                case 10:
                    return '单选题';
                case 20:
                    return '多选题';
                case 30:
                    return '评分题';
                case 40:
                    return '主观题';
                default:
                    return '题目';
            }
        },
        async handleReplyLink() {
            if (!this.textarea.trim()) {
                this.$message.warning(this.$t('请输入内容'));
                return;
            }
            this.replyLoading = true;
            try {
                // 生成预览
                this.previewHtml = markdownToHtml(this.textarea);
                
                // console.log(this.previewHtml)
                // return false;
                this.linkToContent = this.previewHtml;
                // this.textarea = this.previewHtml
                this.handleReply()
                this.previewHtml = '';
            } catch (error) {
                console.error('回复失败:', error);
                this.$message.error(error.message || this.$t('操作失败'));
            } finally {
                this.replyLoading = false;
            }
        },
        async handelSubPerLink() {
            if (!this.textareaper.trim()) {
                this.$message.warning(this.$t('请输入内容'));
                return;
            }
            this.replyLoading = true;
            try {
                // 生成预览
                this.previewHtml = markdownToHtml(this.textareaper);
                
                // console.log(this.previewHtml)
                // return false;
                this.linkToContent = this.previewHtml;
                // this.textareaper = this.previewHtml
                this.handelSubPer()
                this.previewHtml = '';
            } catch (error) {
                console.error('回复失败:', error);
                this.$message.error(error.message || this.$t('操作失败'));
            } finally {
                this.replyLoading = false;
            }
        },
        handleCloseLink(){
            this.dialogVisibleLink = false; // 打开 Dialog 
        },
      async handleDelete(item) {
        this.$nextTick(() => {
          item.delete_loadingdelete_loading = true;
        })
        let res = await deletePostAns({ tpa_id: item.tpa_id });
        if (res.status == 200) {
          this.$message({
            message: res.msg,
            type: 'success',
            customClass: 'mt-60' // 添加自定义类
          });
        }
        await this.getData();
      },
        async handleEssence(item) {
          this.$nextTick(() => {
            item.is_loading = true;
          })
          await essencePostAns({ tpa_id: item.tpa_id });
          await this.getData();
        },
        errorHandler() {
            return true
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },

        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.ac_id = item.user_id;
            this.$refs.avatarDialog.openModal();
            // 
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },

        async getData() {
            let res = await ansList({ id: this.id });
            this.dataList = this.addIsLoading(res.data.post_ans_list);
        },

        addIsLoading(arr) {
            // 返回值是一个新的数组
            return arr.map(item => {
                item.is_loading = false;
                item.delete_loading = false;
                if (item.children && item.children.length > 0) {
                    item.children = this.addIsLoading(item.children);
                }
                return item;
            });
        },
        

        // 电站
        async handleactQuestionLike(item) {
            this.$nextTick(() => {
                item.is_loading = true; 
            })
            // item.is_loading = true;
            // this.likeLoading = true;
            let res = await likePostAns({ tpa_id: item.tpa_id });
            // this.$nextTick(() => {
            //     item.is_loading = false;
            // })

            

            await this.getData();
            // this.likeLoading = false;
        },


        handleReply() {
            let content = (this.linkToContent.length > 0)?this.linkToContent:this.textarea;
            let obj = { tp_id: this.id, tpa_content: content, is_expert: this.is_expert.length > 0 ? this.is_expert[0] : 20 };
            this.replyPostAns(obj);
            this.textarea = '';
        },

        // 关闭回复
        handleClose(){
            this.dialogVisible = false;
            setTimeout(() => {
                this.textareaper = '';
                this.is_expert = [10];
            }, 200);
        },

        handelSubPer() {
            let content = (this.linkToContent.length > 0)?this.linkToContent:this.textareaper;
            this.is_expert = this.is_expert.length > 0 ? this.is_expert[0] : 20;
            let obj = { tp_id: this.id, tpa_content: content, to_user_id: this.personObj.user_id, tpa_pid: this.personObj.tpa_id, is_expert: this.is_expert };
            this.replyPostAns(obj);
            setTimeout(() => {
                this.dialogVisible = false;
                this.textareaper = '';
                this.is_expert = [10];
            }, 200);
        },

        // 回复评论
        handleReplyPer(item) {
            this.dialogVisible = true;
            this.personObj = item;

        },
        // 评论
        async replyPostAns(obj) {
            this.replyLoading = true;
            let res = await replyPostAns(obj);

            if (res.status == 200) {
                this.$message({
                    message: res.msg,
                    type: 'success',
                    customClass: 'mt-60' // 添加自定义类
                });
            }
            this.getData();
            this.replyLoading = false;
        },
    }
}
</script>


<style lang="scss" scoped>
.essence-box {
    position: absolute;
    right: 24px;
    top: -10px;
}
.moderator-box {
    height: 23px;
    line-height: 22px;

    .box-1 {
        // 背景渐变FFA547
        background: linear-gradient(180deg, #FF8B29 0%, #FFA547 100%);
        // background: #FF8E2D;
        padding: 0 16px 0 6px;
        border-radius: 8px 0 0 0;

        .iconfont {
            font-size: 14px;
            position: relative;
            top: -1px;
            color: #ffffff;
        }
    }

    .box-2 {
        background: #FAEAD7;
        position: relative;
        left: -10px;
        color: #FF8E2D;
        font-size: 12px;
        padding: 0 10px;
        border-radius: 12px 0 8px 0;
        border-left: 1px solid #ffffff;
    }
}
.list {
    margin-top: 16px;
    position: relative;

    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
        ::v-deep() {
            a {
                color: #00e;
            }
        }
    }

    .like-box {
        margin-top: 8px;

        .hava-text {
            min-width: 28px;
            display: inline-block;
            text-align: left;
        }

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}

::v-deep() {
    .el-dialog__body {
        padding: 12px 20px 16px;
    }

    .el-dialog {
        border-radius: 8px;
    }

    .dialog-footer {

        .btn1,
        .btn2 {
            min-width: 75px;
            height: 36px;
            border-radius: 30px;
            padding: 0 16px;
        }

        .btn1 {
            background-color: #ffffff;
            border: 1px solid #ededed;
        }

        .btn2 {
            background-color: #D64F31;
            border: none;
        }

        .el-button+.el-button {
            margin-left: 24px;
        }
    }

}

.reply-person {
    background-color: #F8F8F8;
    padding: 16px;
    border-radius: 4px;

    ::v-deep() {
        .el-textarea__inner {
            border: none;
            padding: 0;
            background-color: transparent;
        }
    }
}

.reply-box {
    min-height: 88px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    margin-top: 14px;
    margin-left: 36px;
    padding: 8px 20px 8px 12px;

    ::v-deep() {
        el-textarea {
            height: 100%;

        }

        .el-textarea__inner {
            border: none;
            min-height: 72px !important;

            &::-webkit-scrollbar {
                width: 0;
            }
        }
    }
}

.question-box {
    margin-top: 24px;

    // min-height: 310px;

    .no_news {
        height: 310px;

        p {
            color: rgb(119, 119, 119);

            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 4px;
        }
    }

}

.discu-box {
    padding-top: 40px;
    padding-bottom: 80px;

    .title {
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        font-family: "MicrosoftYaHeiSemibold";
    }
}
.reply-box {
  margin-top: 20px;
  align-items: flex-start; /* 顶部对齐 */
}

.preview-box {
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.content-link {
  color: #409eff;
  text-decoration: none;
  border-bottom: 1px dashed #409eff;
  margin: 0 2px;
}
.content-link:hover {
  color: #66b1ff;
  border-bottom-style: solid;
}
/* 在组件样式部分添加 */
.custom-link-btn  {
    font-size: 18px !important;
}

/* 或者更精确的选择器 */
.custom-link-btn > i {
    font-size: 18px !important;
}

/* 问卷回答样式 - 与普通回复内容保持一致 */
.questionnaire-content {
  margin-left: 36px;
  margin-top: 14px;
  
  .questionnaire-body {
    .questionnaire-answer {
      .ques-item {
        .ques-title {
          font-size: 14px;
          line-height: 22px;
          color: rgb(25, 25, 25);
          display: flex;
          align-items: flex-start;
          margin-bottom: 8px;
          font-weight: 400;

          .ques-no {
            margin-right: 0.2em;
          }

          .type-text {
            color: rgb(25, 25, 25);
            margin-right: 0.2em;
          }

          .title-text {
            margin-right: 0.2em;
            text-align: justify;
            flex: 1;
            margin: 0;
          }
        }

        & + .ques-item {
          margin-top: 12px;
        }

        // 选择题答案样式
        .answer-options {
          margin-left: 16px;
          
          .selected-option {
            font-size: 14px;
            line-height: 22px;
            color: rgb(25, 25, 25);
            font-weight: 400;
            margin-bottom: 2px;
          }
          
          // 追问内容样式 - 与选项样式保持一致
          .probe-content {
            font-size: 14px;
            line-height: 22px;
            color: rgb(25, 25, 25);
            font-weight: 400;
            margin-top: 6px;
            margin-left: 12px;
          }
        }

        // 评分题答案样式 - 去掉下横线，直接显示在选项后
        .score-answers {
          margin-left: 16px;
          
          .score-item-answer {
            font-size: 14px;
            line-height: 22px;
            color: rgb(25, 25, 25);
            font-weight: 400;
            margin-bottom: 2px;
          }
          
          // 评分题追问内容样式 - 与选项样式保持一致
          .probe-content {
            font-size: 14px;
            line-height: 22px;
            color: rgb(25, 25, 25);
            font-weight: 400;
            margin-top: 6px;
            margin-left: 12px;
          }
        }

        // 主观题答案样式
        .subjective-answer {
          font-size: 14px;
          line-height: 22px;
          color: rgb(25, 25, 25);
          font-weight: 400;
          margin-left: 16px;
          background: transparent;
          border: none;
          padding: 0;
          margin-top: 4px;
        }
      }
    }
  }
}

.questionnaire-actions {
  .questionnaire-time {
    color: #666;
    font-size: 12px;
    font-style: italic;
  }
}
</style>